import React, { Component } from "react";

import Button from "@material-ui/core/Button";
import IconButton from '@material-ui/core/IconButton';
import LinearProgress from '@material-ui/core/LinearProgress';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";

export default class ClientServicesSection extends Component {
  render() {
    return (
      <React.Fragment>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 50
          }}
        >
          <Typography component="span" variant="h6" color="inherit">
            Services
          </Typography>
          {this.props.presentation ? null : (
            <Button
              color="primary"
              size="small"
              onClick={this.props.openDialog}
              disabled={this.props.disabled}
            >
              Add
            </Button>
          )}
        </div>
        {this.props.data.length < 1 ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Typography component="span" variant="h6" color="inherit">
              No Services added
            </Typography>
          </div>
        ) : (
          <>
            {this.props.disabled && (
              <LinearProgress
                color="primary"
                style={{ height: 2, marginTop: 20 }}
              />
            )}
            <Paper
              style={
                this.props.disabled
                  ? { padding: "6px 0" }
                  : { padding: "6px 0", marginTop: 20 }
              }
            >
              <List>
                {this.props.data.map((item, i) => {
                  return (
                    <ListItem key={i}>
                      <ListItemText primary={`${i + 1}. ${item}`} />
                      {this.props.presentation ? null : (
                        <ListItemSecondaryAction>
                          {this.props.edit ? (
                            <IconButton disabled={this.props.disabled}>
                              <DeleteIcon
                                onClick={() =>
                                  this.props.deleteService(item)
                                }
                              />
                            </IconButton>
                          ) : (
                            <IconButton disabled={this.props.disabled}>
                              <CloseIcon
                                onClick={() =>
                                  this.props.removeItem("services", i)
                                }
                              />
                            </IconButton>
                          )}
                        </ListItemSecondaryAction>
                      )}
                    </ListItem>
                  );
                })}
              </List>
            </Paper>
          </>
        )}
      </React.Fragment>
    );
  }
}
